/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button,
    FormControlLabel, Switch, TextField, Box
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { PartyGstCodeTable } from "./PartyGstCodeTable";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { customAlaphaNumericOnlyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const PartyGstCode = (props) => {
    const { partyGstdetails, productGstdetails, loader } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [additionalText, setAdditionalText] = useState('');
    const [sez, setSez] = useState(false);

    const [addMore, setAddMore] = useState(false);
    const [errorCode, setErrorCode] = useState(false);
    const [productGst, setProductGst] = useState([]);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [productGstId, setProductGstId] = useState([]);
   // const [emptyProductGst, setEmptyProductGst] = useState('');

    const [isProductGstNew, setIsProductGstNew] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [importVisible, setImportVisible] = useState(false);


    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };
    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const dispatch = useDispatch();



    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Party GST Code', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ code: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'partygst',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id desc',
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    const emptyState = () => {
        setErrorCode(false);
    };

    const emptyStateInput = () => {
        setCode('');
        setDescription('');
        setAdditionalText('');
        setSez(false);
        setIsProductGstNew(false);
        setProductGst([]);
        setProductGstId([]);
    };

    const createGst = (e) => {
        e.preventDefault();
        let emptyCode = customAlaphaNumericOnlyValidation('Gst Code', code);
        emptyState();
        if (emptyCode.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'partygst',
                title: 'Party Gst code',
                details: {
                    code: code,
                    description: description,
                    additionalText: additionalText,
                    isSEZ: sez,
                    productGsts: productGstId
                }
            });
        } else {
            if (emptyCode.errors) {
                setErrorCode(emptyCode.errors);
            }
        }
    }


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorCode(error);
        }
    }, [createDetails, createError]);


    const selectProductGst = (value) => {
        if (value !== '') {
            let p = productGstdetails.filter((el) => { return el.id === value });
            let newArr = productGst.concat(p);
            let newArrId = productGstId.concat(value);
            setProductGst(newArr);
            setProductGstId(newArrId);
           // setEmptyProductGst('');
        }
    };

    const deleteProductGst = (value) => {
        let p = productGst.filter((el) => { return el.id !== value });
        let pId = productGstId.filter((el) => { return el !== value });
        setProductGst(p);
        setProductGstId(pId);
    }

    const handleAddMore = (e) => {
        createGst(e);
        setAddMore(true);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.PARTYGST_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'partygst',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Party GST Code', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Party GST Code-Maintenance'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Party GST Code', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>

                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Party GST Code', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Party Gst code'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Party GST Code', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Party GST Code', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Party GST Code</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Party GST Code', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <PartyGstCodeTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                productGstdetails={productGstdetails}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>

                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Party GST Code'}
                    width={'550px'}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createGst(e)}>
                            <div className={classes.customFormFlexRemoveOverflow}>
                                <div className={classes.customFormFlex}>
                                    <TextField autoComplete='one-time-code'
                                        label={["Party GST Code ", <span key={"Party GST Code"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        error={errorCode ? true : false}
                                        helperText={errorCode}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => setCode(e.target.value)}
                                    />
                                    <TextField autoComplete='one-time-code'
                                        label='Description'
                                        variant={'standard'}
                                        className={clsx(classes.margin30t)}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}

                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                    <TextField autoComplete='one-time-code'
                                        label='Additional Text'
                                        variant={'standard'}
                                        className={clsx(classes.margin30t)}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => setAdditionalText(e.target.value)}
                                    />
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                        }}
                                        control={<Switch size='small' className={clsx(classes.customSwitch)}
                                            onChange={(e) => setSez(!sez)}
                                        />}
                                        label="SEZ"
                                        labelPlacement="top"
                                        checked={sez ? true : false}
                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                    />
                                </div>
                                <div>
                                    <div className={clsx(classes.PrimaryCard2)}> Link Product GST Code</div>
                                    <Row className={clsx(classes.PrimaryCard2RowAlign)}>
                                        <Col className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center">
                                                <NavLink
                                                    to='#'
                                                    className={clsx(classes.customLink)}
                                                    onClick={(e) => setIsProductGstNew(true)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Link Product GST Code</span>
                                                </NavLink>
                                            </Space>
                                        </Col>
                                    </Row>
                                    <TableContainer className={classes.partyGstFormTable}>
                                        <Table sx={{ minWidth: '495px' }} className={clsx(classes.productTableRoot)}>
                                            <TableHead>
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell>{'Product GST Code'}</TableCell>
                                                    <TableCell sx={{ width: '65px' }}>{'Percentage'}</TableCell>
                                                    <TableCell sx={{ width: '45px' }}>{'Actions'}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    productGst && productGst?.length > 0 && productGst?.map((data, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell>{data.code}</TableCell>
                                                            <TableCell>{`${data.percentage}%`}</TableCell>
                                                            <TableCell
                                                                className={classes.textAlignRight}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                    onClick={(e) => deleteProductGst(data.id)}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }

                                                {
                                                    productGst && productGst?.length === 0 && (
                                                        <TableRow>
                                                            <TableCell colSpan="3">
                                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Product GST'}</p>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                                {
                                                    isProductGstNew && (
                                                        <TableRow>
                                                            <TableCell>
                                                                <AutoCompleteComponent
                                                                    name={["Select"]}
                                                                    heads={[{ 'key': 'code', 'name': 'Name' }]}
                                                                    details={productGstdetails}
                                                                    parentValue={[]}
                                                                    onChange={(data) => selectProductGst(data.id)}
                                                                    //parentError={error?.defaultCustomerId}
                                                                    position={"top"}
                                                                />
                                                            </TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell className={classes.textAlignRight}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                    onClick={(e) => setIsProductGstNew(false)}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                    >
                                        Save & Close
                                    </Button>
                                    <Button
                                        key="add"
                                        onClick={(e) => handleAddMore(e)}
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                    >
                                        Add more
                                    </Button>
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Party Gst code'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={partyGstdetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default PartyGstCode